import React from "react";
import { MenuItem, Spinner } from "@chakra-ui/react";
import { IoCopyOutline } from "react-icons/io5";
import { useCopy } from "./duck";

const Copy: React.FC = () => {
  const { copy, loading } = useCopy();

  return (
    <MenuItem
      onClick={copy}
      color="gray.900"
      fontSize="sm"
      icon={loading ? <Spinner size="xs" /> : <IoCopyOutline size="12px" />}
    >
      Create new case from current
    </MenuItem>
  );
};

export default Copy;
